/**
 * Texts for History page
 */
export const historyPageText = {
    title: 'O percurso da CamDiab',
    titleMeta: 'Investigação clínica no caminho para o CamAPS FX',
    descriptionMeta: 'Uma cronologia de como a equipa responsável pelo CamAPS FX passou a ajudar pessoas com diabetes através do nosso algoritmo de Cambridge.',
    localeMeta: 'pt_PT',

    keywords:
        'história camaps, história camaps fx, ' +
        '',
    journeyHeading: 'O percurso da CamDiab',
    timelineHeading: 'Uma cronologia de como a equipa responsável pelo CamAPS FX passou a ajudar pessoas com diabetes através do nosso algoritmo de Cambridge.',
    year2006_2010dates: '2006–2010',
    year2006_2010heading: 'Primeiros ensaios em clínica',
    year2006_2010text: 'Início do projeto do pâncreas artificial em Cambridge, com ensaios em crianças com ' +
        'diabetes tipo 1. Integração no JDRF Artificial Pancreas Consortium. ' +
        'O algoritmo de Cambridge foi testado em condições de stress após exercício e consumo de álcool ' +
        'em adultos com diabetes tipo 1. O algoritmo de Cambridge foi avaliado em mulheres grávidas com diabetes tipo 1.',
    year2011_2014dates: '2011–2014',
    year2011_2014heading: 'Ensaios de viabilidade apenas noturnos e em vida livre',
    year2011_2014text: 'A utilização noturna do algoritmo de Cambridge foi avaliada em crianças, adultos e ' +
        'mulheres grávidas com diabetes tipo 1. O algoritmo de Cambridge foi utilizado de dia e de noite durante sete dias ' +
        'por adultos com diabetes tipo 1.',
    year2015_2016dates: '2015–2016',
    year2015_2016heading: 'Ensaios curtos de dia e de noite em vida livre',
    year2015_2016text: 'O algoritmo de Cambridge foi utilizado por adultos com diabetes tipo 1 bem controlada durante quatro semanas. ' +
        'O algoritmo de Cambridge foi utilizado por adolescentes com diabetes tipo 1 durante três semanas.',
    year2017_2018dates: '2017–2018',
    year2017_2018heading: 'Ensaios mais longos de dia e de noite e em crianças pequenas',
    year2017_2018text: 'O algoritmo de Cambridge foi utilizado durante três meses por crianças e adultos com diabetes tipo 1. ' +
        'O algoritmo de Cambridge foi utilizado durante mais de dois anos por crianças e adolescentes desde o diagnóstico de diabetes. ' +
        'O algoritmo de Cambridge foi utilizado em crianças pequenas dos 1 aos 7 anos com diabetes tipo 1.',
    year2019_2019dates: '2019',
    year2019_2019heading: 'Transição para o CamAPS FX ',
    year2019_2019text: 'A aplicação CamAPS FX foi utilizada por adultos mais velhos com diabetes tipo 1. A aplicação CamAPS FX foi utilizada ' +
        'durante toda a gravidez por mulheres com diabetes tipo 1. A aplicação CamAPS FX foi utilizada em ' +
        'crianças dos 1 aos 7 anos com diabetes tipo 1.',
    year2020_2020dates: 'A partir de 2020',
    year2020_2020heading: 'Aprovação regulamentar, comercialização e realização de ensaios clínicos',
    year2020_2020text: 'Aplicação CamAPS FX com marcação CE para utilização na UE, no Reino Unido, na Nova Zelândia, na Austrália e no Canadá. ' +
        'A investigação prossegue para avaliar os benefícios e apoiar a comparticipação.',
};
